export const CHART_COLORS = {
  primary: '#223f5e',
  success: '#22c55e',
  warning: '#f59e0b',
  destructive: '#811517',
  muted: '#7a8fa3',
  info: '#689ebc',
};

export const SCORE_BUCKET_COLORS: Record<string, string> = {
  '90-100': '#0c2a45',
  '80-89': '#143654',
  '70-79': '#1e4d6e',
  '60-69': '#286488',
  '50-59': '#3e7da3',
  '40-49': '#5692b5',
  '30-39': '#689ebc',
  '20-29': '#8ab5cc',
  '10-19': '#abccdd',
  '0-9': '#cce0ec',
};

export const STATUS_COLORS: Record<string, string> = {
  new: '#689ebc',
  actioned: '#223f5e',
  dismissed: '#811517',
};

export const FORWARD_COLORS = {
  edited: '#f59e0b',
  keptOriginal: '#22c55e',
  noOriginal: '#7a8fa3',
  reordered: '#f59e0b',
};

/** Generate an array of blue shades from dark to light for N bars. */
export const BLUE_GRADIENT = [
  '#0c2a45',
  '#143654',
  '#1e4d6e',
  '#286488',
  '#3e7da3',
  '#5692b5',
  '#689ebc',
  '#7aabca',
  '#8ab5cc',
  '#abccdd',
];

export function blueGradient(count: number): string[] {
  if (count <= 1) return [BLUE_GRADIENT[0]];
  return Array.from({ length: count }, (_, i) => {
    const t = i / (count - 1);
    const idx = Math.round(t * (BLUE_GRADIENT.length - 1));
    return BLUE_GRADIENT[idx];
  });
}

export function baseLayout(overrides: Record<string, unknown> = {}): Record<string, unknown> {
  return {
    autosize: true,
    margin: { l: 50, r: 20, t: 10, b: 50 },
    paper_bgcolor: 'transparent',
    plot_bgcolor: 'transparent',
    font: {
      family: 'Geist, system-ui, sans-serif',
      size: 12,
      color: '#5c7186',
    },
    xaxis: {
      gridcolor: 'rgba(148,163,184,0.15)',
      ...(overrides.xaxis as object),
    },
    yaxis: {
      gridcolor: 'rgba(148,163,184,0.15)',
      ...(overrides.yaxis as object),
    },
    ...overrides,
  };
}
